import React from "react";
import { Reveal } from "./shared";
import { SCHEDULE, DAYS } from "../../lib/data";

export const Schedule = ({ onNav }) => (
  <section className="section alt" id="schedule" data-testid="schedule-section">
    <div className="container">
      <Reveal><p className="eyebrow">Class Schedule</p></Reveal>
      <Reveal delay={0.05}>
        <h2 className="section-title" style={{ marginTop: 16 }}>Show up. <span className="accent">Show out.</span></h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div style={{ marginTop: 44, background: "var(--black)", borderRadius: "var(--radius-lg)", padding: 56,
          color: "#fff", position: "relative", overflow: "hidden", boxShadow: "var(--shadow-strong)" }} className="schedule-card">
          <div style={{ position: "absolute", top: -80, right: -80, width: 260, height: 260,
            background: "radial-gradient(circle,rgba(242,169,59,0.25),transparent 70%)" }} />
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap",
            gap: 24, marginBottom: 44, position: "relative", zIndex: 1 }}>
            <div>
              <p style={{ color: "rgba(255,255,255,.6)", fontSize: 13, letterSpacing: ".1em",
                textTransform: "uppercase", marginBottom: 12 }}>Training Days</p>
              <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
                {DAYS.map((d) => (
                  <span key={d} style={{ padding: "10px 20px", borderRadius: 100, border: "1px solid rgba(242,169,59,0.4)",
                    fontSize: 13, letterSpacing: "0.08em", textTransform: "uppercase", color: "var(--gold)", fontWeight: 700 }}>{d}</span>
                ))}
              </div>
            </div>
            <button className="btn btn-gold" onClick={() => onNav("contact")} data-testid="schedule-reserve-btn">Reserve Your Spot</button>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 22, position: "relative", zIndex: 1 }} className="schedule-rows">
            {SCHEDULE.map((s) => (
              <div key={s.time} style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.09)",
                borderRadius: "var(--radius-md)", padding: "26px 28px" }}>
                <div style={{ fontFamily: "'Bebas Neue'", fontSize: 32, color: "var(--gold)" }}>{s.time}</div>
                <div style={{ fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.55)" }}>{s.level}</div>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
